import React, { useContext } from "react";
import { exact, func, number, string } from "prop-types";
import { Card, Heading } from "uikit/components";
import styles from "./RegionIndicatorCard.module.styl";
import Chart from "react-apexcharts";
import cx from "classnames";
import IconTooltip from "uikit/components/IconTooltip/IconTooltip";
import { percentageLevels } from "utils/indicator/indicatorSettings.js";
import { chartOptions, chartWidth, smallChartWidth } from "utils/chart/chartOptions";
import { MediaContext } from "app/media/MediaContext";

export default function RegionIndicatorCard({
    title,
    percentage = null,
    numerator,
    denominator,
    info,
    descriptionTitle,
    descriptionText,
    additionalDescriptionText,
    fiveFK,
    onClick,
    dataTestName,
}) {
    const { isDesktop } = useContext(MediaContext);
    const options = chartOptions(
        percentageLevels.indicatorColor(percentage),
        isDesktop ? "24px" : "16px",
    );
    const series = percentage == null ? [] : [percentage];

    return (
        <Card
            borderRadius={"giant"}
            padding={"none"}
            className={cx(styles.form, onClick && styles.link && (percentage == null ? styles.noPercentage: ''))}
            onClick={onClick}
            borderColor={percentageLevels.indicatorColor(percentage).colorName}
            name={dataTestName}
        >
            <div className={styles.content}>
                <div className={styles.textInfo}>
                    <div className={styles.heading}>
                        <Heading className={styles.cardHeader} size={"h2"}>
                            {title}
                            <div className={styles.icon}>
                                <IconTooltip trigger={"hover"}>
                                    <div className={styles.infoPanel}>{info}</div>
                                </IconTooltip>
                            </div>
                        </Heading>
                    </div>
                    <div className={styles.indicators}>
                        <div className={styles.numerator}>{numerator}</div>
                        {denominator != null && (
                            <div className={styles.denominator}>/{denominator}</div>
                        )}
                    </div>
                    <Heading size={"h3"} className={styles.descriptionTitle}>
                        {descriptionTitle}
                    </Heading>
                    {descriptionText && denominator != null && (
                        <div className={styles.descriptionText}>
                            {descriptionText}: {denominator - numerator}{" "}
                            {additionalDescriptionText != null ? additionalDescriptionText : ""}
                        </div>
                    )}
                    {fiveFK && (
                        <div className={styles.fiveFKText}>
                            {fiveFK.title}: {fiveFK.text}
                        </div>
                    )}
                </div>
                {percentage !== null && (
                    <div className={styles.chart}>
                        <Chart
                            options={options}
                            series={series}
                            type="radialBar"
                            width={isDesktop ? chartWidth : smallChartWidth}
                        />
                    </div>
                )}
            </div>
        </Card>
    );
}

RegionIndicatorCard.propTypes = {
    title: string.isRequired,
    percentage: number | null,
    numerator: number.isRequired,
    denominator: number,
    info: string.isRequired,
    descriptionTitle: string.isRequired,
    descriptionText: string,
    additionalDescriptionText: string,
    fiveFK: exact({
        title: string.isRequired,
        text: string.isRequired,
    }),
    onClick: func,
    dataTestName: string,
};
